import { render, staticRenderFns } from "./PFGFrunpayslips.vue?vue&type=template&id=186c464e"
import script from "./PFGFrunpayslips.vue?vue&type=script&lang=js"
export * from "./PFGFrunpayslips.vue?vue&type=script&lang=js"
import style0 from "./PFGFrunpayslips.vue?vue&type=style&index=0&id=186c464e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports